<ionic-selectable
  *ngIf="(owners$ | async)?.loading === false"
  [(ngModel)]="ownerId"
  [items]="(owners$ | async)?.data || []"
  itemValueField="id"
  itemTextField="name"
  [canSearch]="true"
  [hasInfiniteScroll]="true"
  [shouldStoreItemValue]="true"
  (onInfiniteScroll)="getMoreOwners($event)"
  (onOpen)="onOpen($event, true)"
  (onSearch)="searchOwners($event)"
  closeButtonSlot="end"
  #ownerSelectComponent
>
  <ng-template ionicSelectablePlaceholderTemplate>
    Owner
  </ng-template>
  <ng-template ionicSelectableFooterTemplate>
    <ion-toolbar>
      <ion-button expand="full" (click)="selectOwner()">
        confirm
      </ion-button>
    </ion-toolbar>
  </ng-template>
</ionic-selectable>

<ion-spinner name="dots" *ngIf="(owners$ | async)?.loading"></ion-spinner>
